
// import React, {
//     useState,
//     useEffect,
//     useCallback,
//     useMemo
// } from "react";
// import axios from "../axios";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import SctModal from "../modals/SctModal";
// import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
//
// const GameExecution = () => {
//
//     //  Local state
//
//     const [projects, setProjects] = useState([]);
//     const [selectedProject, setSelectedProject] = useState("");
//     const [games, setGames] = useState([]);
//     const [builds, setBuilds] = useState([]);
//     const [selectedBuild, setSelectedBuild] = useState("All Builds");
//     const [statusFilter, setStatusFilter] = useState("All Status");
//     const [providerFilter, setProviderFilter] = useState("All Provider");
//     const [date, setDate] = useState(() =>
//         new Date().toISOString().slice(0, 10)
//     );
//     const [currentPage, setCurrentPage] = useState(1);
//     const [loading, setLoading] = useState(false);
//     const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
//     const [isModalOpen, setModalOpen] = useState(false);
//     const [modalUrl, setModalUrl] = useState("");
//     const [manualVerifications, setManualVerifications] = useState({});
//     // “Now” ticker (for Jenkins lockout, etc.)
//     const [now, setNow] = useState(Date.now());
//     const [disabledUntil, setDisabledUntil] = useState(null);
//     const gamesPerPage = 20;
//
//
//     //  1) Load the list of projects this user is allowed to see
//     //     (calls GET /api/game-execution/projects)
//
//     useEffect(() => {
//         setLoading(true);
//         axios
//             .get("/game-execution/projects")
//             .then((res) => {
//                 // Expected shape: { success: true, projects: ["Khelo", "Alpha", ...] }
//                 if (res.data.success && Array.isArray(res.data.projects)) {
//                     setProjects(res.data.projects);
//                 } else {
//                     console.error("Unexpected /projects response:", res.data);
//                     setProjects([]);
//                 }
//             })
//             .catch((err) => {
//                 console.error("Error fetching projects:", err);
//                 setProjects([]);
//             })
//             .finally(() => {
//                 setLoading(false);
//             });
//     }, []);
//
//
//     //  2) Update “now” every minute (for 35-minute Jenkins lockout)
//
//     useEffect(() => {
//         const interval = setInterval(() => setNow(Date.now()), 60_000);
//         return () => clearInterval(interval);
//     }, []);
//
//
//     //  3) Auto-clear the 35-minute Jenkins lock when time’s up
//
//     useEffect(() => {
//         if (!disabledUntil) return;
//         const msLeft = disabledUntil - Date.now();
//         if (msLeft <= 0) {
//             setDisabledUntil(null);
//             return;
//         }
//         const timer = setTimeout(() => setDisabledUntil(null), msLeft);
//         return () => clearTimeout(timer);
//     }, [disabledUntil]);
//
//
//     //  4) Fetch game executions for the selectedProject & date
//     //     (calls GET /api/game-execution/projects/:projectName/executions?date=YYYY-MM-DD)
//
//     const getGameExecutionData = useCallback(() => {
//         if (!selectedProject) {
//             // No project chosen → clear
//             setGames([]);
//             setBuilds([]);
//             return;
//         }
//         if (!date) {
//             // No date chosen → clear
//             setGames([]);
//             setBuilds([]);
//             setCurrentPage(1);
//             return;
//         }
//
//         setLoading(true);
//         axios
//             .get(
//                 `/game-execution/projects/${encodeURIComponent(
//                     selectedProject
//                 )}/executions?date=${date}`
//             )
//             .then((res) => {
//                 // Expect: { success: true, executions: [ { id, provider_name, game_name, execution_date, … }, … ] }
//                 if (!res.data.success || !Array.isArray(res.data.executions)) {
//                     console.error("Unexpected /executions response:", res.data);
//                     setGames([]);
//                     setBuilds([]);
//                     return;
//                 }
//                 const allExecs = res.data.executions;
//
//                 // Build unique “latest per build_id” list for the chosen date
//                 const buildMap = allExecs.reduce((map, g) => {
//                     const prev = map.get(g.build_id);
//                     if (
//                         !prev ||
//                         new Date(g.execution_date) > new Date(prev.execution_date)
//                     ) {
//                         map.set(g.build_id, {
//                             build_id: g.build_id,
//                             execution_date: g.execution_date,
//                         });
//                     }
//                     return map;
//                 }, new Map());
//
//                 const buildsList = Array.from(buildMap.values()).sort(
//                     (a, b) =>
//                         new Date(b.execution_date) - new Date(a.execution_date)
//                 );
//
//                 setGames(allExecs);
//                 setBuilds(buildsList);
//                 setSelectedBuild("All Builds");
//                 setCurrentPage(1);
//             })
//             .catch((err) => {
//                 console.error("Error fetching executions:", err);
//                 setGames([]);
//                 setBuilds([]);
//             })
//             .finally(() => {
//                 setLoading(false);
//             });
//     }, [selectedProject, date]);
//
//     // Re-run whenever the user picks a new project or date
//     useEffect(() => {
//         getGameExecutionData();
//     }, [getGameExecutionData]);
//
//
//     //  Derived data: providers, recent‐build highlighting, filtering, sorting, paging
//
//     // Provider dropdown
//     const providersList = useMemo(
//         () => ["All Provider", ...new Set(games.map((g) => g.provider_name))],
//         [games]
//     );
//
//     // Builds from the last 3 hours
//     const recentBuildIds = useMemo(() => {
//         const threeHoursAgo = now - 3 * 60 * 60 * 1000;
//         return builds
//             .filter((b) => new Date(b.execution_date).getTime() >= threeHoursAgo)
//             .map((b) => b.build_id);
//     }, [builds, now]);
//
//     // (A) Filter by build
//     const filteredByBuild = useMemo(() => {
//         if (selectedBuild === "All Builds") return games;
//         return games.filter(
//             (g) => g.build_id.toString() === selectedBuild.toString()
//         );
//     }, [games, selectedBuild]);
//
//     // (B) Filter by status
//     const filteredByStatus =
//         statusFilter === "All Status"
//             ? filteredByBuild
//             : filteredByBuild.filter(
//                 (g) =>
//                     g.status &&
//                     g.status.toLowerCase() === statusFilter.toLowerCase()
//             );
//
//     // (C) Filter by provider
//     const filteredGames =
//         providerFilter === "All Provider"
//             ? filteredByStatus
//             : filteredByStatus.filter((g) => g.provider_name === providerFilter);
//
//     // (D) Sort
//     const sortedGames = useMemo(() => {
//         const sortable = [...filteredGames];
//         if (!sortConfig.key) return sortable;
//
//         sortable.sort((a, b) => {
//             let aKey, bKey;
//             switch (sortConfig.key) {
//                 case "provider":
//                     aKey = a.provider_name || "";
//                     bKey = b.provider_name || "";
//                     return sortConfig.direction === "asc"
//                         ? aKey.localeCompare(bKey)
//                         : bKey.localeCompare(aKey);
//                 case "status":
//                     aKey = a.status || "";
//                     bKey = b.status || "";
//                     return sortConfig.direction === "asc"
//                         ? aKey.localeCompare(bKey)
//                         : bKey.localeCompare(aKey);
//                 case "date":
//                     aKey = new Date(a.execution_date);
//                     bKey = new Date(b.execution_date);
//                     return sortConfig.direction === "asc"
//                         ? aKey - bKey
//                         : bKey - aKey;
//                 default:
//                     return 0;
//             }
//         });
//         return sortable;
//     }, [filteredGames, sortConfig]);
//
//     // (E) Pagination
//     const totalPages = Math.ceil(sortedGames.length / gamesPerPage);
//     const startIdx = (currentPage - 1) * gamesPerPage;
//     const paginatedGames = sortedGames.slice(
//         startIdx,
//         startIdx + gamesPerPage
//     );
//
//     // (F) Pass/fail tally
//     const statusCounts = filteredGames.reduce(
//         (acc, g) => {
//             const s = g.status?.toLowerCase();
//             if (s === "pass") acc.pass++;
//             else if (s === "fail") acc.fail++;
//             return acc;
//         },
//         { pass: 0, fail: 0 }
//     );
//
//
//     //  Handlers
//
//     const handleSort = (key) => {
//         let direction = "asc";
//         if (sortConfig.key === key && sortConfig.direction === "asc") {
//             direction = "desc";
//         }
//         setSortConfig({ key, direction });
//     };
//
//     const isTriggerDisabled = loading || disabledUntil !== null;
//
//     const handleJenkinsExecution = async () => {
//         const code = prompt("Enter access code:");
//         if (code !== "9951") {
//             alert("❌ Invalid access code.");
//             return;
//         }
//         setDisabledUntil(Date.now() + 35 * 60 * 1000);
//         setLoading(true);
//         try {
//             await axios.post("/jenkins/execute", {
//                 jobName: "Khelo_GameRunner",
//                 tag: "@KHELO-Casino_Game",
//             });
//             alert("✅ Jenkins job triggered!");
//             getGameExecutionData();
//         } catch {
//             alert("❌ Failed to trigger Jenkins build.");
//         } finally {
//             setLoading(false);
//         }
//     };
//
//     const handleThumbClick = async (gameId, type) => {
//         setManualVerifications((prev) => ({ ...prev, [gameId]: type }));
//         try {
//             await axios.post(`/game-execution/manual-verification/${gameId}`, {
//                 verification: type,
//             });
//             getGameExecutionData();
//         } catch {
//             alert("Failed manual verification.");
//         }
//     };
//
//     const exportToExcel = () => {
//         const data = sortedGames.map((g, i) => ({
//             SNo: i + 1,
//             Provider: g.provider_name,
//             Game: g.game_name,
//             URL: g.url,
//             Status: g.status,
//             Date: g.execution_date,
//             Build: g.build_id,
//         }));
//         const ws = XLSX.utils.json_to_sheet(data);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Game Executions");
//         const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//         saveAs(
//             new Blob([buf]),
//             `GameExecution_${selectedProject}_${date || "all"}.xlsx`
//         );
//     };
//
//
//     //  5) Render component
//
//     return (
//         <div className="p-6">
//             <h2 className="text-2xl font-bold text-center mb-4">
//                 Game Execution Results
//             </h2>
//
//             {/* ─── Project Selection Buttons ─── */}
//             <div className="flex flex-wrap justify-center gap-4 mb-4">
//                 {projects.map((p) => (
//                     <button
//                         key={p}
//                         onClick={() => setSelectedProject(p)}
//                         className={`px-4 py-2 rounded-lg font-semibold text-white ${
//                             selectedProject === p
//                                 ? "bg-blue-700"
//                                 : "bg-blue-500 hover:bg-blue-600"
//                         }`}
//                     >
//                         {p}
//                     </button>
//                 ))}
//             </div>
//
//             {!selectedProject ? (
//                 <div className="text-center italic text-gray-600 mb-8">
//                     👩‍💻 Select a project to view results 🔎
//                 </div>
//             ) : (
//                 <>
//                     {/* ─── Jenkins Trigger Button ─── */}
//                     <div className="flex justify-end mb-4">
//                         <button
//                             onClick={handleJenkinsExecution}
//                             disabled={isTriggerDisabled}
//                             className="
//                 bg-blue-700 text-white px-4 py-2 rounded
//                 hover:bg-blue-500 disabled:opacity-50
//                 transition-opacity duration-500
//               "
//                         >
//                             Trigger Jenkins
//                         </button>
//                     </div>
//
//                 {/* ─── Filters: date / build / status / provider / totals ─── */}
//                     <div className="flex flex-wrap justify-center items-center gap-4 mb-6">
//                         <input
//                             type="date"
//                             value={date}
//                             onChange={(e) => setDate(e.target.value)}
//                             className="border p-2 rounded"
//                         />
//                         <button
//                             onClick={() => setDate("")}
//                             className="bg-gray-200 px-3 py-2 rounded"
//                         >
//                             Clear Date
//                         </button>
//
//                         {builds.length > 1 && (() => {
//                             const hasRecent = builds.some((b) =>
//                                 recentBuildIds.includes(b.build_id)
//                             );
//                             return (
//                                 <div className="relative inline-block">
//                                     {hasRecent && (
//                                         <div
//                                             className="
//                         absolute -top-2 right-0
//                         bg-indigo-500 text-white text-xs font-semibold
//                         px-2 py-1 rounded-full animate-bounce
//                       "
//                                         >
//                                             New build available!
//                                         </div>
//                                     )}
//                                     <select
//                                         value={selectedBuild}
//                                         onChange={(e) => setSelectedBuild(e.target.value)}
//                                         className={`
//                       border p-2 rounded focus:outline-none
//                       transition-shadow duration-300
//                       ${
//                                             hasRecent
//                                                 ? "ring-2 ring-indigo-400 ring-opacity-50 ring-offset-2 shadow-lg shadow-indigo-400/20"
//                                                 : ""
//                                         }
//                     `}
//                                     >
//                                         <option>All Builds</option>
//                                         {builds.map((b) => {
//                                             const isRecentOpt = recentBuildIds.includes(
//                                                 b.build_id
//                                             );
//                                             return (
//                                                 <option
//                                                     key={b.build_id}
//                                                     value={b.build_id}
//                                                     className={
//                                                         isRecentOpt
//                                                             ? "bg-indigo-100 font-semibold"
//                                                             : ""
//                                                     }
//                                                 >
//                                                     {b.build_id}
//                                                     {isRecentOpt ? " (Recent)" : ""}
//                                                 </option>
//                                             );
//                                         })}
//                                     </select>
//                                 </div>
//                             );
//                         })()}
//
//                         <select
//                             value={statusFilter}
//                             onChange={(e) => setStatusFilter(e.target.value)}
//                             className="border p-2 rounded"
//                         >
//                             <option>All Status</option>
//                             <option>Pass</option>
//                             <option>Fail</option>
//                         </select>
//                         <select
//                             value={providerFilter}
//                             onChange={(e) => setProviderFilter(e.target.value)}
//                             className="border p-2 rounded"
//                         >
//                             {providersList.map((prov, i) => (
//                                 <option key={i}>{prov}</option>
//                             ))}
//                         </select>
//                         <div className="text-sm">
//                             Total: {filteredGames.length} | ✅ Pass:{" "}
//                             {statusCounts.pass} | ❌ Fail: {statusCounts.fail}
//                         </div>
//                     </div>
//
//                 {/* ─── Table or “No Data” message ─── */}
//                 {!date ? (
//                     <div className="text-center py-20 italic text-gray-600">
//                         Please select a date to view game results
//                     </div>
//                 ) : loading ? (
//                     <div className="text-center py-20 animate-pulse">
//                         Loading...
//                     </div>
//                 ) : games.length === 0 ? (
//                     <div className="text-center py-20 italic text-gray-600">
//                         No game executions found for {date}
//                     </div>
//                 ) : (
//                     <>
//                         <div className="overflow-y-scroll max-h-[600px] border rounded mb-4">
//                             <table className="w-full table-auto text-sm">
//                                 <thead className="bg-blue-100 sticky top-0">
//                                 <tr>
//                                     <th className="p-2 border">S.No</th>
//                                     <th
//                                         className="p-2 border cursor-pointer"
//                                         onClick={() => handleSort("provider")}
//                                     >
//                                         Provider ⇅{" "}
//                                         {sortConfig.key === "provider" &&
//                                             (sortConfig.direction === "asc"
//                                                 ? "▲"
//                                                 : "▼")}
//                                     </th>
//                                     <th className="p-2 border">Game</th>
//                                     <th className="p-2 border">Link</th>
//                                     <th
//                                         className="p-2 border cursor-pointer"
//                                         onClick={() => handleSort("status")}
//                                     >
//                                         Status ⇅{" "}
//                                         {sortConfig.key === "status" &&
//                                             (sortConfig.direction === "asc"
//                                                 ? "▲"
//                                                 : "▼")}
//                                     </th>
//                                     <th className="p-2 border">Screenshot</th>
//                                     <th
//                                         className="p-2 border cursor-pointer"
//                                         onClick={() => handleSort("date")}
//                                     >
//                                         Date ⇅{" "}
//                                         {sortConfig.key === "date" &&
//                                             (sortConfig.direction === "asc"
//                                                 ? "▲"
//                                                 : "▼")}
//                                     </th>
//                                 </tr>
//                                 </thead>
//                                 <tbody>
//                                 {paginatedGames.map((game, idx) => {
//                                     const currentVerification =
//                                         manualVerifications[game.id] ||
//                                         game.manual_verification;
//                                     const isFail =
//                                         game.status?.toLowerCase() === "fail";
//                                     return (
//                                         <tr
//                                             key={game.id}
//                                             className="text-center hover:bg-gray-50"
//                                         >
//                                             <td className="p-2 border">
//                                                 {startIdx + idx + 1}
//                                             </td>
//                                             <td className="p-2 border">
//                                                 {game.provider_name}
//                                             </td>
//                                             <td className="p-2 border">
//                                                 {game.game_name}
//                                             </td>
//                                             <td className="p-2 border">
//                                                 <a
//                                                     href={game.url}
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                     className="underline text-blue-600"
//                                                 >
//                                                     Open
//                                                 </a>
//                                             </td>
//                                             <td
//                                                 className={`p-2 border font-bold ${
//                                                     isFail
//                                                         ? "text-red-600"
//                                                         : "text-green-600"
//                                                 }`}
//                                             >
//                                                 {game.status}
//                                                 {isFail && (
//                                                     <div className="mt-1 flex justify-center gap-2">
//                                                         {currentVerification === "none" ? (
//                                                             <>
//                                                                 <button
//                                                                     onClick={() =>
//                                                                         handleThumbClick(
//                                                                             game.id,
//                                                                             "up"
//                                                                         )
//                                                                     }
//                                                                     className="text-green-600 hover:text-green-800"
//                                                                 >
//                                                                     <FaThumbsUp />
//                                                                 </button>
//                                                                 <button
//                                                                     onClick={() =>
//                                                                         handleThumbClick(
//                                                                             game.id,
//                                                                             "down"
//                                                                         )
//                                                                     }
//                                                                     className="text-red-600 hover:text-red-800"
//                                                                 >
//                                                                     <FaThumbsDown />
//                                                                 </button>
//                                                             </>
//                                                         ) : currentVerification === "up" ? (
//                                                             <span className="text-green-600 text-xs">
//                                     Manually Passed
//                                   </span>
//                                                         ) : (
//                                                             <span className="text-red-600 text-xs">
//                                     Manually Failed
//                                   </span>
//                                                         )}
//                                                     </div>
//                                                 )}
//                                             </td>
//                                             <td className="p-2 border">
//                                                 {game.screenshot_path ? (
//                                                     <img
//                                                         src={`${process.env.REACT_APP_API_URL.replace(
//                                                             /\/api$/,
//                                                             ""
//                                                         )}${game.screenshot_path}`}
//                                                         alt="Screenshot"
//                                                         className="w-32 cursor-pointer rounded"
//                                                         onClick={() => {
//                                                             setModalOpen(true);
//                                                             setModalUrl(
//                                                                 `${process.env.REACT_APP_API_URL.replace(
//                                                                     /\/api$/,
//                                                                     ""
//                                                                 )}${game.screenshot_path}`
//                                                             );
//                                                         }}
//                                                     />
//                                                 ) : (
//                                                     <span className="italic text-gray-400">
//                                 No Screenshot
//                               </span>
//                                                 )}
//                                             </td>
//                                             <td className="p-2 border">
//                                                 {new Date(
//                                                     game.execution_date
//                                                 ).toLocaleString("en-IN", {
//                                                     day: "2-digit",
//                                                     month: "numeric",
//                                                     year: "numeric",
//                                                     hour: "numeric",
//                                                     minute: "2-digit",
//                                                     hour12: true,
//                                                 })}
//                                             </td>
//                                         </tr>
//                                     );
//                                 })}
//                                 </tbody>
//                             </table>
//                         </div>
//
//                         {/* ─── Pagination & Export ─── */}
//                         <div className="flex justify-between flex-wrap items-center gap-4">
//                             <button
//                                 onClick={exportToExcel}
//                                 className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
//                             >
//                                 Export to Excel
//                             </button>
//                             {totalPages > 1 && (
//                                 <div className="flex gap-3">
//                                     <button
//                                         onClick={() =>
//                                             setCurrentPage((p) => Math.max(p - 1, 1))
//                                         }
//                                         disabled={currentPage === 1}
//                                         className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
//                                     >
//                                         Previous
//                                     </button>
//                                     <span className="text-sm">
//                       Page {currentPage} of {totalPages}
//                     </span>
//                                     <button
//                                         onClick={() =>
//                                             setCurrentPage((p) => Math.min(p + 1, totalPages))
//                                         }
//                                         disabled={currentPage === totalPages}
//                                         className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
//                                     >
//                                         Next
//                                     </button>
//                                 </div>
//                             )}
//                         </div>
//                         <SctModal
//                             isOpen={isModalOpen}
//                             onClose={() => setModalOpen(false)}
//                             imgUrl={modalUrl}
//                         />
//                     </>
//                 )}
//                 </>
//             )}
//         </div>
//     );
// };
//
// export default GameExecution;



import React, {
    useState,
    useEffect,
    useCallback,
    useMemo,
    useContext, // ← added
} from "react";
import axios from "../axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SctModal from "../modals/SctModal";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
import { AuthContext } from "../AuthContext";

const GameExecution = () => {
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState("");
    const [games, setGames] = useState([]);
    const [builds, setBuilds] = useState([]);
    const [selectedBuild, setSelectedBuild] = useState("All Builds");
    const [statusFilter, setStatusFilter] = useState("All Status");
    const [providerFilter, setProviderFilter] = useState("All Provider");
    const [date, setDate] = useState(() =>
        new Date().toISOString().slice(0, 10)
    );
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalUrl, setModalUrl] = useState("");
    const [manualVerifications, setManualVerifications] = useState({});
    const [now, setNow] = useState(Date.now());
    const [disabledUntil, setDisabledUntil] = useState(null);

    const gamesPerPage = 20;

    const { roles } = useContext(AuthContext);
    const canTriggerJenkins = roles.some((r) =>
        ["SuperAdmin", "Admin", "Automation_Tester", "Team_Lead"].includes(r)
    );

    useEffect(() => {
        setLoading(true);
        axios
            .get("/game-execution/projects")
            .then((res) => {
                if (res.data.success && Array.isArray(res.data.projects)) {
                    setProjects(res.data.projects);
                } else {
                    setProjects([]);
                    console.error("Unexpected /projects response:", res.data);
                }
            })
            .catch((err) => {
                console.error("Error fetching projects:", err);
                setProjects([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    
    //  2) Update “now” every minute
    
    useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), 60_000);
        return () => clearInterval(interval);
    }, []);

    
    //  3) Auto-clear Jenkins lock when time’s up
    
    useEffect(() => {
        if (!disabledUntil) return;
        const msLeft = disabledUntil - Date.now();
        if (msLeft <= 0) {
            setDisabledUntil(null);
            return;
        }
        const timer = setTimeout(() => setDisabledUntil(null), msLeft);
        return () => clearTimeout(timer);
    }, [disabledUntil]);

    
    //  4) Fetch game executions when project or date changes
    
    const getGameExecutionData = useCallback(() => {
        if (!selectedProject) {
            setGames([]);
            setBuilds([]);
            return;
        }
        if (!date) {
            setGames([]);
            setBuilds([]);
            setCurrentPage(1);
            return;
        }

        setLoading(true);
        axios
            .get(
                `/game-execution/projects/${encodeURIComponent(
                    selectedProject
                )}/executions?date=${date}`
            )
            .then((res) => {
                if (!res.data.success || !Array.isArray(res.data.executions)) {
                    console.error("Unexpected /executions response:", res.data);
                    setGames([]);
                    setBuilds([]);
                    return;
                }
                const allExecs = res.data.executions;

                // Build unique “latest per build_id” list
                const buildMap = allExecs.reduce((map, g) => {
                    const prev = map.get(g.build_id);
                    if (
                        !prev ||
                        new Date(g.execution_date) > new Date(prev.execution_date)
                    ) {
                        map.set(g.build_id, {
                            build_id: g.build_id,
                            execution_date: g.execution_date,
                        });
                    }
                    return map;
                }, new Map());

                const buildsList = Array.from(buildMap.values()).sort(
                    (a, b) => new Date(b.execution_date) - new Date(a.execution_date)
                );

                setGames(allExecs);
                setBuilds(buildsList);
                setSelectedBuild("All Builds");
                setCurrentPage(1);
            })
            .catch((err) => {
                console.error("Error fetching executions:", err);
                setGames([]);
                setBuilds([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [selectedProject, date]);

    useEffect(() => {
        getGameExecutionData();
    }, [getGameExecutionData]);

    
    //  Derived data: filtering, sorting, paging
    

    // Provider dropdown
    const providersList = useMemo(() => {
        return ["All Provider", ...new Set(games.map((g) => g.provider_name))];
    }, [games]);

    // Builds from last 3 hours
    const recentBuildIds = useMemo(() => {
        const threeHoursAgo = now - 3 * 60 * 60 * 1000;
        return builds
            .filter((b) => new Date(b.execution_date).getTime() >= threeHoursAgo)
            .map((b) => b.build_id);
    }, [builds, now]);

    // (A) Filter by build
    const filteredByBuild = useMemo(() => {
        if (selectedBuild === "All Builds") return games;
        return games.filter(
            (g) => g.build_id.toString() === selectedBuild.toString()
        );
    }, [games, selectedBuild]);

    // (B) Filter by status
    const filteredByStatus =
        statusFilter === "All Status"
            ? filteredByBuild
            : filteredByBuild.filter(
                (g) =>
                    g.status && g.status.toLowerCase() === statusFilter.toLowerCase()
            );

    // (C) Filter by provider
    const filteredGames =
        providerFilter === "All Provider"
            ? filteredByStatus
            : filteredByStatus.filter((g) => g.provider_name === providerFilter);

    // (D) Sort
    const sortedGames = useMemo(() => {
        const sortable = [...filteredGames];
        if (!sortConfig.key) return sortable;
        sortable.sort((a, b) => {
            let aKey, bKey;
            switch (sortConfig.key) {
                case "provider":
                    aKey = a.provider_name || "";
                    bKey = b.provider_name || "";
                    return sortConfig.direction === "asc"
                        ? aKey.localeCompare(bKey)
                        : bKey.localeCompare(aKey);
                case "status":
                    aKey = a.status || "";
                    bKey = b.status || "";
                    return sortConfig.direction === "asc"
                        ? aKey.localeCompare(bKey)
                        : bKey.localeCompare(aKey);
                case "date":
                    aKey = new Date(a.execution_date);
                    bKey = new Date(b.execution_date);
                    return sortConfig.direction === "asc"
                        ? aKey - bKey
                        : bKey - aKey;
                default:
                    return 0;
            }
        });
        return sortable;
    }, [filteredGames, sortConfig]);

    // (E) Pagination
    const totalPages = Math.ceil(sortedGames.length / gamesPerPage);
    const startIdx = (currentPage - 1) * gamesPerPage;
    const paginatedGames = sortedGames.slice(
        startIdx,
        startIdx + gamesPerPage
    );

    // (F) Pass/fail tally
    const statusCounts = filteredGames.reduce(
        (acc, g) => {
            const s = g.status?.toLowerCase();
            if (s === "pass") acc.pass++;
            else if (s === "fail") acc.fail++;
            return acc;
        },
        { pass: 0, fail: 0 }
    );

    
    //  Handlers
    
    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const isTriggerDisabled = loading || disabledUntil !== null;

    const handleJenkinsExecution = async () => {
        const code = prompt("Enter access code:");
        if (code !== "9951") {
            alert("❌ Invalid access code.");
            return;
        }
        setDisabledUntil(Date.now() + 35 * 60 * 1000);
        setLoading(true);
        try {
            await axios.post("/jenkins/execute", {
                jobName: "Khelo_GameRunner",
                tag: "@KHELO-Casino_Game",
            });
            alert("✅ Jenkins job triggered!");
            getGameExecutionData();
        } catch {
            alert("❌ Failed to trigger Jenkins build.");
        } finally {
            setLoading(false);
        }
    };

    const handleThumbClick = async (gameId, type) => {
        setManualVerifications((prev) => ({ ...prev, [gameId]: type }));
        try {
            await axios.post(
                `/game-execution/manual-verification/${gameId}`,
                { verification: type }
            );
            getGameExecutionData();
        } catch {
            alert("Failed manual verification.");
        }
    };

    const exportToExcel = () => {
        const data = sortedGames.map((g, i) => ({
            SNo: i + 1,
            Provider: g.provider_name,
            Game: g.game_name,
            URL: g.url,
            Status: g.status,
            Date: g.execution_date,
            Build: g.build_id,
        }));
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Game Executions");
        const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        saveAs(
            new Blob([buf]),
            `GameExecution_${selectedProject}_${date || "all"}.xlsx`
        );
    };

    
    //  5) Render component
    
    return (
        <div className="p-6">
            <h2 className="text-2xl font-bold text-center mb-4">
                Game Execution Results
            </h2>

            {/* ─── Project Selection Area ─── */}
            {!selectedProject ? (
                <section className="mb-6 bg-white p-4 rounded shadow">
                    <h3 className="text-xl font-semibold text-gray-700 mb-3 text-center">
                        Select a Project
                    </h3>
                    {loading ? (
                        <div className="text-center text-gray-500 py-4">
                            Loading projects…
                        </div>
                    ) : projects.length === 0 ? (
                        <div className="text-center text-gray-500 py-4">
                            No projects available
                        </div>
                    ) : (
                        <div className="flex flex-wrap justify-center gap-4">
                            {projects.map((p) => (
                                <button
                                    key={p}
                                    onClick={() => setSelectedProject(p)}
                                    className={`px-4 py-2 rounded-lg font-semibold text-white ${
                                        selectedProject === p
                                            ? "bg-blue-700"
                                            : "bg-blue-500 hover:bg-blue-600"
                                    }`}
                                >
                                    {p}
                                </button>
                            ))}
                        </div>
                    )}
                </section>
            ) : (
                <section className="mb-6 bg-white rounded shadow flex items-center justify-between">
                    <div className="p-4">
                        <p className="text-lg text-gray-800">
                            Project:{" "}
                            <span className="font-semibold text-blue-700">
              {selectedProject}
            </span>
                        </p>
                    </div>
                    <button
                        onClick={() => {
                            setSelectedProject("");
                            setDate(new Date().toISOString().slice(0, 10));
                            setSelectedBuild("All Builds");
                            setStatusFilter("All Status");
                            setProviderFilter("All Provider");
                            setGames([]);
                            setBuilds([]);
                        }}
                        className="text-sm px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded"
                    >
                        Change Project
                    </button>
                </section>
            )}

            {selectedProject && (
                <>
                    {/* ─── Jenkins Trigger Button (conditionally visible) ─── */}
                    {canTriggerJenkins && (
                        <div className="flex justify-end mb-4">
                            <button
                                onClick={handleJenkinsExecution}
                                disabled={isTriggerDisabled}
                                className="
                  bg-blue-700 text-white px-4 py-2 rounded
                  hover:bg-blue-500 disabled:opacity-50
                  transition-opacity duration-500
                "
                            >
                                Trigger Jenkins
                            </button>
                        </div>
                    )}

                    {/* ─── Filters ─── */}
                    <div className="flex flex-wrap justify-center items-center gap-4 mb-6">
                        <input
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            className="border p-2 rounded"
                        />
                        <button
                            onClick={() => setDate("")}
                            className="bg-gray-200 px-3 py-2 rounded"
                        >
                            Clear Date
                        </button>

                        {builds.length > 1 && (
                            <div className="relative inline-block">
                                {(() => {
                                    const hasRecent = builds.some((b) =>
                                        recentBuildIds.includes(b.build_id)
                                    );
                                    return hasRecent ? (
                                        <div
                                            className="
                        absolute -top-2 right-0
                        bg-indigo-500 text-white text-xs font-semibold
                        px-2 py-1 rounded-full animate-bounce
                      "
                                        >
                                            New build available!
                                        </div>
                                    ) : null;
                                })()}
                                <select
                                    value={selectedBuild}
                                    onChange={(e) => setSelectedBuild(e.target.value)}
                                    className={`
                    border p-2 rounded focus:outline-none
                    ${
                                        recentBuildIds.includes(Number(selectedBuild))
                                            ? "ring-2 ring-indigo-400 ring-opacity-50 ring-offset-2 shadow-lg shadow-indigo-400/20"
                                            : ""
                                    }
                  `}
                                >
                                    <option>All Builds</option>
                                    {builds.map((b) => {
                                        const isRecentOpt = recentBuildIds.includes(b.build_id);
                                        return (
                                            <option
                                                key={b.build_id}
                                                value={b.build_id}
                                                className={
                                                    isRecentOpt ? "bg-indigo-100 font-semibold" : ""
                                                }
                                            >
                                                {b.build_id}
                                                {isRecentOpt ? " (Recent)" : ""}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}

                        <select
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            className="border p-2 rounded"
                        >
                            <option>All Status</option>
                            <option>Pass</option>
                            <option>Fail</option>
                        </select>

                        <select
                            value={providerFilter}
                            onChange={(e) => setProviderFilter(e.target.value)}
                            className="border p-2 rounded"
                        >
                            {providersList.map((prov, i) => (
                                <option key={i}>{prov}</option>
                            ))}
                        </select>

                        <div className="text-sm">
                            Total: {filteredGames.length} | ✅ Pass: {statusCounts.pass} | ❌ Fail:{" "}
                            {statusCounts.fail}
                        </div>
                    </div>

                    {/* ─── Table or No Data ─── */}
                    {!date ? (
                        <div className="text-center py-20 italic text-gray-600">
                            Please select a date to view game results
                        </div>
                    ) : loading ? (
                        <div className="text-center py-20 animate-pulse">Loading...</div>
                    ) : games.length === 0 ? (
                        <div className="text-center py-20 italic text-gray-600">
                            No game executions found for {date}
                        </div>
                    ) : (
                        <>
                            <div className="overflow-y-scroll max-h-[600px] border rounded mb-4">
                                <table className="w-full table-auto text-sm">
                                    <thead className="bg-blue-100 sticky top-0">
                                    <tr>
                                        <th className="p-2 border">S.No</th>
                                        <th
                                            className="p-2 border cursor-pointer"
                                            onClick={() => handleSort("provider")}
                                        >
                                            Provider ⇅{" "}
                                            {sortConfig.key === "provider" &&
                                                (sortConfig.direction === "asc" ? "▲" : "▼")}
                                        </th>
                                        <th className="p-2 border">Game</th>
                                        <th className="p-2 border">Link</th>
                                        <th
                                            className="p-2 border cursor-pointer"
                                            onClick={() => handleSort("status")}
                                        >
                                            Status ⇅{" "}
                                            {sortConfig.key === "status" &&
                                                (sortConfig.direction === "asc" ? "▲" : "▼")}
                                        </th>
                                        <th className="p-2 border">Screenshot</th>
                                        <th
                                            className="p-2 border cursor-pointer"
                                            onClick={() => handleSort("date")}
                                        >
                                            Date ⇅{" "}
                                            {sortConfig.key === "date" &&
                                                (sortConfig.direction === "asc" ? "▲" : "▼")}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {paginatedGames.map((game, idx) => {
                                        const currentVerification =
                                            manualVerifications[game.id] || game.manual_verification;
                                        const isFail = game.status?.toLowerCase() === "fail";
                                        return (
                                            <tr
                                                key={game.id}
                                                className="text-center hover:bg-gray-50"
                                            >
                                                <td className="p-2 border">{startIdx + idx + 1}</td>
                                                <td className="p-2 border">{game.provider_name}</td>
                                                <td className="p-2 border">{game.game_name}</td>
                                                <td className="p-2 border">
                                                    <a
                                                        href={game.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="underline text-blue-600"
                                                    >
                                                        Open
                                                    </a>
                                                </td>
                                                <td
                                                    className={`p-2 border font-bold ${
                                                        isFail ? "text-red-600" : "text-green-600"
                                                    }`}
                                                >
                                                    {game.status}
                                                    {isFail && (
                                                        <div className="mt-1 flex justify-center gap-2">
                                                            {currentVerification === "none" ? (
                                                                <>
                                                                    <button
                                                                        onClick={() =>
                                                                            handleThumbClick(game.id, "up")
                                                                        }
                                                                        className="text-green-600 hover:text-green-800"
                                                                    >
                                                                        <FaThumbsUp />
                                                                    </button>
                                                                    <button
                                                                        onClick={() =>
                                                                            handleThumbClick(game.id, "down")
                                                                        }
                                                                        className="text-red-600 hover:text-red-800"
                                                                    >
                                                                        <FaThumbsDown />
                                                                    </button>
                                                                </>
                                                            ) : currentVerification === "up" ? (
                                                                <span className="text-green-600 text-xs">
                                    Manually Passed
                                  </span>
                                                            ) : (
                                                                <span className="text-red-600 text-xs">
                                    Manually Failed
                                  </span>
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="p-2 border">
                                                    {game.screenshot_path ? (
                                                        <img
                                                            src={`${process.env.REACT_APP_API_URL.replace(
                                                                /\/api$/,
                                                                ""
                                                            )}${game.screenshot_path}`}
                                                            alt="Screenshot"
                                                            className="w-32 cursor-pointer rounded"
                                                            onClick={() => {
                                                                setModalOpen(true);
                                                                setModalUrl(
                                                                    `${process.env.REACT_APP_API_URL.replace(
                                                                        /\/api$/,
                                                                        ""
                                                                    )}${game.screenshot_path}`
                                                                );
                                                            }}
                                                        />
                                                    ) : (
                                                        <span className="italic text-gray-400">
                                No Screenshot
                              </span>
                                                    )}
                                                </td>
                                                <td className="p-2 border">
                                                    {new Date(
                                                        game.execution_date
                                                    ).toLocaleString("en-IN", {
                                                        day: "2-digit",
                                                        month: "numeric",
                                                        year: "numeric",
                                                        hour: "numeric",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    })}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination & Export */}
                            <div className="flex justify-between flex-wrap items-center gap-4">
                                <button
                                    onClick={exportToExcel}
                                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                                >
                                    Export to Excel
                                </button>
                                {totalPages > 1 && (
                                    <div className="flex gap-3">
                                        <button
                                            onClick={() =>
                                                setCurrentPage((p) => Math.max(p - 1, 1))
                                            }
                                            disabled={currentPage === 1}
                                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                                        >
                                            Previous
                                        </button>
                                        <span className="text-sm">
                      Page {currentPage} of {totalPages}
                    </span>
                                        <button
                                            onClick={() =>
                                                setCurrentPage((p) => Math.min(p + 1, totalPages))
                                            }
                                            disabled={currentPage === totalPages}
                                            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                                <SctModal
                                    isOpen={isModalOpen}
                                    onClose={() => setModalOpen(false)}
                                    imgUrl={modalUrl}
                                />
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default GameExecution;
